import { FC, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { checkCustomPaymentStatus } from "services/myOrders";
import { MyOrder } from "ts/shared/interfaces/MOResponse";
import withErrorBoundary from "../withErrorBoundary";
import LoaderMain from "../LoaderMain";

const MyOrderPaymentPage: FC = () => {
  const [searchParams] = useSearchParams();
  const transactionId = searchParams.get('transactionId');
  const paymentUrl = searchParams.get('paymentUrl');
  const [triesCount, setTriesCount] = useState(60);
  const timeout = useRef<any>();
  const navigate = useNavigate();
  const [success, setSuccess] = useState<MyOrder | undefined>();

  useEffect(() => {
    check(transactionId || '');

    return () => clearTimeout(timeout.current);
  }, []); // eslint-disable-line

  const check = async (transactionId: string) => {
    setTriesCount((prev) => prev - 1);

    const responseCheck = await checkCustomPaymentStatus(transactionId);

    if (responseCheck?.bookingModel?.statusGoToXX) {
      navigate('/status-xx');
      sessionStorage.setItem(
        'bookStatusXX',
        JSON.stringify({
          orderId: responseCheck.bookingModel?.orderId,
          transactionId,
          url: 'ILPackages/SubmitScreenshots',
        })
      );
    } else if (responseCheck?.statusGoToMOrReq) {
      setSuccess(responseCheck.order);
    } else if (responseCheck?.orderHasBeenPaid) {
      setSuccess(responseCheck.order);
    } else if (responseCheck?.hasErrors) {
      sessionStorage.setItem('errMessage', responseCheck?.errorMessage);
      sessionStorage.setItem(
        'bookFail',
        JSON.stringify({
          orderId: responseCheck.order?.orderId,
          transactionId,
          url: 'ILPackages/SubmitScreenshots',
        })
      );
      navigate('/fail');
    } else if (triesCount > 0) {
      timeout.current = setTimeout(() => check(transactionId), 5000);
    }
  };

  return (
    <div>
      {paymentUrl && !success && <iframe src={paymentUrl} title="payment" style={{
        width: '100%', height: 'calc(100vh - 50px)', position: 'relative', zIndex: 10000

      }} />}
      {success && <div className="text-center text-success text-bold text-lg" style={{ marginTop: '100px' }}>Payment successful for segment {success.fullSegment.orderSegId}</div>}
      {!success && (
        <LoaderMain systemProducts="Hotels" systemProductsDetails="LoadingDetails" />
      )}
    </div>
  );
};

export default withErrorBoundary(MyOrderPaymentPage, 'MyOrderPaymentPage');